import appendSlide from './appendSlide';
import prependSlide from './prependSlide';
import addSlide from './addSlide';
import removeSlide from './removeSlide';
import removeAllSlides from './removeAllSlides';
export default {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};


//////////////////
// WEBPACK FOOTER
// /home/juan/projetos/mix/maracajauimagens.com.br/web/app/themes/boilerplate/node_modules/swiper/esm/components/core/manipulation/index.js
// module id = 81
// module chunks = 0